import { Input } from '@progress/kendo-react-inputs';
import React, { useState, useEffect } from 'react';

// 사용법
// 그리드의 셀 안에 Input을 넣을 때 사용한다.
// 사용하는 이유는 그리드 셀 안에 Input을 넣으면 한글자씩 잘려서 입력이 되기 때문이다.
// 1. 해당 컴포넌트를 임포트 한다.
// 2. 그리드의 셀에 설정한다. /*
//   <GridColumn title="저장" width="80px" cell={gridSaveCell} />

function GridInputCell(props) {
  const { dataItem, field } = props;
  const isDailyAlarm = dataItem.eventType === 11010;
  let [input, setInput] = useState(dataItem[field]);

  // Input 입력 시 이벤트
  const onChangeInput = e => {
    setInput(e.value);
    props.dataItem[field] = e.value;
  };

  return (
    <td>
      {isDailyAlarm ? <div style={{ margin: '3px' }}>-</div> : <Input onChange={onChangeInput} value={dataItem.processingContent ? dataItem.processingContent : ""} style={{ width: '100%' }}></Input>}
    </td>
  );
}

export default GridInputCell;
